//rule: alphabetic order
export const strings = {
    AbbreviationForLargestDiagonal: 'Diag Maior',
    AbbreviationForLeftEyeHeight: 'Alt OE',
    AbbreviationForRightEyeHeight: 'Alt OD',
    AccordingLoggedUser: 'De acordo com o usuário logado',
    Addition: 'Adição',
    AdditionalAddress: 'Complemento',
    Address: 'Endereço',
    AddToBatch: 'Adicionar ao Lote',
    All: 'Todos',
    AllItemsHaveAlreadyBeenFulfilledOnSale: 'Todos os itens já foram entregues na venda.',
    AlertType: 'Tipo de Alerta',
    AlertForClientNotInformed: 'Cliente não informado.',
    AlertForOrderWithoutShippingLine: 'Sem linha de transporte.',
    AlertForOrderWithoutStockCoverage: 'O estoque global não possui cobertura para este pedido.',
    AlertForLateOrder: 'Prazo interno vencido.',
    Alter: 'Alterar',
    AmaroIntegrations: 'Integrações Amaro',
    AppliedFilters: 'Filtros Aplicados',
    Apply: 'Aplicar',
    ApproveConference: 'Aprovar Conferência',
    ApproveDegree: 'Aprovar Grau',
    ApproveReceivedOrder: 'Confirmar Pedido Recebido',
    ArchiveDeliveredOrder: 'Arquivar Pedido Entregue',
    Attach: 'Anexar',
    AwaitingOrder: 'Aguardando Pedido',
    AwaitingPickup: 'Aguardando Retirada',
    AwaitingPickupInStore: 'Aguardando Retirada em Loja',
    Axis: 'Eixo',
    AxisLeft: 'Eixo Esq',
    AxisRight: 'Eixo Dir',
    TransportOrderBaseReport: 'Relatório Base de Pedidos em Transporte',
    Back: 'Voltar',
    BasicData: 'Dados Básicos',
    Batch: 'Lote',
    BatchCompletedWithSuccess: 'Lote concluído com sucesso!',
    Batches: 'Lotes',
    BillingAddress: 'Endereço de Cobrança',
    Brazil: 'Brasil',
    Bridge: 'Ponte',
    Cancel: 'Cancelar',
    Canceled: 'Cancelado',
    Carrier: 'Transportadora',
    CellPhone: 'Celular',
    Change: 'Alteração',
    ChangeCustomer: 'Alterar cliente',
    Changedby: 'Alterado por',
    ChangeRecipeOnlyIfNecessary: 'Alterar Receita (só se for necessário)',
    ChangeStateOfOrder: 'Alterar Estado do Pedido',
    ChangeStateOfDegree: 'Alterar Estado do Grau',
    ChangedOf: 'Alterado de',
    ChangedUntil: 'Alterado até',
    CheckAssembly: 'Conferir Montagem',
    City: 'Município',
    Clear: 'Limpar',
    ClearFilter: 'Limpar Filtro',
    Client: 'Cliente',
    ClientDeadline: 'Prazo Cli',
    ClientWorkingDays: 'Dias Úteis Cli',
    ClientName: 'Nome Cliente',
    Close: 'Sair',
    Closed: 'Fechado',
    Creation: 'Criação',
    Communications: 'Comunicações',
    InternalCommunications: 'Comunicações Internas',
    InternalCommunication: 'Comunicação Interna',
    InternalDeadline: 'Prazo Int',
    InternalWorkingDays: 'Dias Úteis Int',
    Complement: 'Complemento',
    Completed: 'Concluído',
    CompleteBatch: 'Concluir Lote',
    Confirm: 'Confirmar',
    ConfirmItemsForGlobalPicker: 'Confirmar itens para Separação Global',
    ConfirmLensesReceived: 'Confirmar Lentes Recebidas',
    ConfirmNotifications: 'Confirmar Notificações',
    ConfirmNote: 'Confirmar Observação',
    ConfirmCommunication: 'Confirmar Comunicação',
    ConfirmProductGroup: 'Confirmar Grupo de Produtos',
    ConfirmRecipe: 'Confirmar Receita',
    ConfirmShippingLine: 'Confirmar Linha de Transporte',
    ConfirmSeparation: 'Confirmar Separação',
    ConfirmSeparationInBatch: 'Confirmação de Separação em Lote',
    ConfirmedRecipe: 'Receita confirmada',
    ConfirmDNP: 'Confirmar DNP',
    ConfirmedDNP: 'DNP confirmada',
    Confirmed: 'Confirmado',
    ConfirmIfInformedFieldValueIsCorrect: (fieldName: string) => `Confirme se o valor informado no campo ${fieldName} está realmente correto.`,
    Consult: 'Consultar',
    Createdat: 'Criado em',
    Createdby: 'Criado por',
    CreatedOf: 'Criado de',
    CreatedUntil: 'Criado até',
    CustomerDeadline: 'Prazo cliente',
    CustomerDeadlineOf: 'Prazo cliente de',
    CustomerDeadlineUntil: 'Prazo cliente até',
    CustomerDetails: 'Detalhes do Cliente',
    CustomerNotInformed: 'Cliente não informado',
    Customers: 'Clientes',
    CustomerSuccessfullyRegistered: 'Cliente cadastrado com sucesso!',
    CustomerSuccessfullyUpdated: 'Cliente alterado com sucesso!',
    Cylindrical: 'Cilíndrico',
    CylindricalLeft: 'Cilíndrico Esq',
    CylindricalRight: 'Cilíndrico Dir',
    Date: 'Data',
    DateCriation: 'Data Criação',
    DateOfCriation: 'Data da criação',
    DateOfChange: 'Data da alteração',
    DateExpiration: 'Data Expiração',
    Description: 'Descrição',
    Degree: 'Grau',
    Delete: 'Excluir',
    Delivered: 'Entregue',
    DeliveredOf: 'Entregue de',
    DeliveredUntil: 'Entregue até',
    Details: 'Detalhes',
    Diagnostic: 'Diagnóstico',
    DiagnosticForFar: 'Diagnóstico para Longe',
    DiagnosticForNear: 'Diagnóstico para Perto',
    DNP: 'DNP',
    DNPLeft: 'DNP Esq',
    DNPRight: 'DNP Dir',
    DNPsconfirmed: 'DNPs confirmadas',
    DNPLinks: 'Links DNP',
    DigitalLensCertificates: 'Certificados Digitais de Lente',
    DisapproveConference: 'Reprovar Conferência',
    DisapproveDegree: 'Reprovar Grau',
    DisapproveOrder: 'Reprovar Pedido',
    DisapproveLensesReceived: 'Reprovar Lentes Recebidas',
    DocumentNumber: 'Número do Documento',
    DoYouReallyWantToDeleteTheRecipe: 'Você realmente quer excluir a receita?',
    Edit: 'Editar',
    Email: 'E-mail',
    Enter: 'Entrar',
    EnterAtLeastOneEmailOrAtLeastOneMobileNumber: 'Informe pelo menos um e-mail ou pelo menos um número de celular!',
    EnterMessage: 'Informe a mensagem!',
    EnterOrderNote: 'Informe a observação!',
    Eye: 'Olho',
    ExportReport: 'Exportar Relatório',
    Far: 'Longe',
    File: 'Arquivo',
    FileSuccessfullyAttached: 'Arquivo anexado com sucesso!',
    Filter: 'Filtrar',
    Fiscal: 'Fiscal',
    For: 'Para',
    Frame: 'Armação',
    FulfilledBy: 'Entregue por',
    FulfilledOnSale: 'Entregue na Venda',
    GeneralInThePlural: 'Gerais',
    GeneralReports: 'Relatórios Gerais',
    GeneralSettings: 'Configurações Gerais',
    GenerateBatch: 'Gerar Lote',
    GetNewLink: 'Obter Novo Link',
    GuideOfShipping: 'Guia de Remessa',
    GroupedGeneralReport: 'Relatório Geral Agrupado',
    Height: 'Altura',
    Historic: 'Histórico',
    Home: 'Home',
    Import: 'Importar',
    InformFulfilledItemsOnSale: 'Informar itens entregues na venda',
    InformUserAndPassword: 'Informe usuário e senha!',
    InformTheCustomerEmail: 'Informe o e-mail do cliente',
    InformTheCustomerName: 'Informe o nome do cliente',
    InformTheCustomerLastName: 'Informe o sobrenome do cliente',
    InformTheNote: 'Informe a observação',
    InformTheStateOfOrder: 'Informe o Estado do Pedido',
    InformTheStateOfDegree: 'Informe o Estado do Grau',
    InformeTheZipCode: 'Informe o CEP',
    IntegrationWithLensCuttingMachine: 'Integração com Cortadora de Lente',
    InternalDeadlineExpired: 'Prazo interno vencido',
    Issue: 'Emissão',
    Items: 'Itens',
    LabelsOfPackingDanfe: 'Etiquetas de Empacotamento Danfe',
    LabelsOfPackingSimple: 'Etiquetas de Empacotamento Simples',
    LabelsOfPackingDanfeInZpl: 'Etiquetas de Empacotamento Danfe em ZPL',
    LabelsOfPackingDanfeInPdf: 'Etiquetas de Empacotamento Danfe em PDF',
    LabelsOfPackingSimpleInZpl: 'Etiquetas de Empacotamento Simples em ZPL',
    LabelsOfPackingSimpleInPdf: 'Etiquetas de Empacotamento Simples em PDF',
    LargestDiagonal: 'Diagonal Maior',
    LastChange: 'Última alteração',
    LastConsult: 'Última Consulta',
    LastName: 'Sobrenome',
    LastStatusPackage: 'Último Status do Pacote',
    LastStatus: 'Último Status',
    Left: 'Esquerdo',
    LeftEye: 'Olho Esquerdo',
    LeftEyeAcronym: 'OE',
    Lens: 'Lente',
    LabelsOfLensCertification: 'Etiquetas de Certificação de Lente',
    LabelsOfLensCertificationInPdf: 'Etiquetas de Certificação de Lente em PDF',
    LabelsOfLensCertificationInZpl: 'Etiquetas de Certificação de Lente em ZPL',
    LensMaterial: 'Material da Lente',
    LensSeparationList: 'Lista de Separação de Lentes',
    Link: 'Link',
    Linked: 'Vinculada',
    Linking: 'Vinculação',
    ListNFes: 'Notas Fiscais',
    ListOfSeparation: 'Lista de Separação',    
    ListOfMailsSeparateByVirgule: 'Lista de e-mails (separar por vírgula)',
    ListOfPhonesSeparatedByVirgule: 'Lista de celulares (separar por vírgula, informar o código do país e o DDD)',
    Location: 'Localização',
    Login: 'Login',
    LogisticsOf: 'Logística de',
    LongTitle: 'Sistema de Logística',
    MakeLinking: 'Realizar Vinculação',
    Manage: 'Administrar',
    ManageAmaroIntegrations: 'Administrar Integrações Amaro',
    ManageTransport: 'Administrar Transporte',
    ManageDnpLinks: 'Administrar Links DNP',
    Message: 'Mensagem',
    MessageToPrintingSelectedOrdersEmpty: 'Selecione pelo menos um pedido. Caso já tenha selecionado atualize a lista e tente novamente.',
    MessageToFileFormatInvalid: 'Formato de arquivo inválido!',
    Material: 'Material',
    Model: 'Modelo',
    Multifocal: 'Multifocal',
    Name: 'Nome',
    Near: 'Perto',
    Neighborhood: 'Bairro',
    New: 'Novo',
    NewBatch: 'Novo Lote',
    NewCommunication: 'Nova Comunicação',
    NewNotification: 'Nova Notificação',
    NewNote: 'Nova Observação',
    NewProductGroup: 'Novo Grupo de Produtos',
    NewRecipe: 'Nova Receita',
    NFCe: 'NFC-e',
    NFe: 'NF-e',    
    NoFilterApplied: 'Nenhum filtro aplicado',
    None: 'Nenhum',
    NoneNoteFound: 'Nenhuma observação encontrada!',
    NoneNotificationFound: 'Nenhuma notificação encontrada!',
    NoneProductGroupingFound: 'Nenhum grupo de produtos encontrado!',
    NoneRecipeFound: 'Nenhuma receita encontrada!',
    NoneRecipeLinked: 'Nenhuma receita vinculada!',
    NoneRecipeLinkedToOrder: 'Nenhuma receita vinculada ao pedido!',
    NoneRecordFound: 'Nenhum registro encontrado',
    NoneRecordFoundForInformedFilters: 'Nenhum registro encontrado para os filtros informados',
    NoneCollectPackageFound: 'Nenhuma coleta de pacote encontrada!',    
    NoneShippingLineFound: 'Nenhuma linha de transporte encontrada!',
    NoneStatusCollectPackageFound: 'Nenhum status de pacote encontrado!',    
    NoneInternalCommunicationFound: 'Nenhuma comunicação interna encontrada!',    
    Not: 'Não',
    NotDone: 'Não realizada',
    Notes: 'Observações',
    Notifications: 'Notificações',
    NotifyCustomers: 'Notificar Clientes',
    NotifyCustomersToCollectRecipeAndDNPs: 'Notificar clientes para coleta de receita e DNPs',
    NotifyReadyOrder: 'Notificar Pedido Pronto',
    NoteForPrescriptionGlassesForDifferentPeoples: '[pedido possui oculos de grau para pessoas diferentes]',
    Number: 'Número',
    Ok: 'Ok',
    OnAlertBy: 'Em alerta por',
    Order: 'Pedido',
    Orders: 'Pedidos',
    OrderDate: 'Data Pedido',
    OrderDetails: 'Detalhes do Pedido',
    OrderNonDegree: 'Pedido não Grau',
    OrderNotes: 'Observações do Pedido',
    OrderNumber: 'Número Pedido',
    OrderNum: 'Nº Pedido',
    OrderWithDegree: 'Pedido com Grau',
    OrderWithoutShippingLine: 'Sem linha de transporte',
    OrdersWithoutBatch: 'Pedidos sem Lote',
    OrderOf: 'Pedido de',
    OrderUntil: 'Pedido até',
    Opened: 'Em Aberto',
    Options: 'Opções',
    OtherOptions: 'Outras Opções',
    OtherInformations: 'Outras Informações',
    OriginatedBy: 'Originado por',
    OpsSomethingWrongCompletingBatch: 'Ops! Não consegui concluir o lote. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongDuringAuthentication: 'Ops! Não consegui fazer a autenticação. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongGeneratingBatch: 'Ops! Não consegui gerar o lote. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongGeneratingFile: 'Ops! Não consegui gerar o arquivo. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongGeneratingReport: 'Ops! Não consegui gerar o relatório. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongGettingTheData: 'Ops! Não consegui obter os dados. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongGettingTheFilterOptions: 'Ops! Algo deu errado ao obter opções de filtro.',
    OpsSomethingWrongSendTheData: 'Ops! Não consegui enviar os dados. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongAddingOrderToBatch: 'Ops! Não consegui adicionar pedido no lote. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongRemovingOrderFromBatch: 'Ops! Não consegui remover pedido do lote. Tente novamente e se o problema persistir avise o time tech.',
    OpsSomethingWrongSaving: 'Ops! Não consegui salvar os dados. Tente novamente e se o problema persistir avise o time tech.',
    Paid: 'Pago',
    PaidOrderOf: 'Pedido pago de',
    PaidOrderUntil: 'Pedido pago até',
    Password: 'Senha',
    Payment: 'Pagamento',
    PendingAutomaticRealization: 'Pendente de realização automática',
    PendingManualRealization: 'Pendente de realização manual',
    Perform: 'Efetuar',
    PerformVirtualCollect: 'Realizar Coleta Virtual',
    Period: 'Período',
    PeriodType: 'Tipo do Período',
    Phone: 'Telefone',
    Price: 'Preço',
    Principal: 'Principal',
    Print: 'Imprimir',
    ProblemOnManufacturing: 'Problema na Montagem',
    ProblemOnLens: 'Problema na Lente',
    ProcessFinishedSuccessfully: 'Processo concluído com sucesso!',
    ProcessFinishedWithFailures: 'Processo concluído com falhas!',
    ProductGroups: 'Grupos de Produtos',
    PublicPlace: 'Logradouro',
    Quantity: 'Quantidade',
    ReadyForPickup: 'Pronto para Retirada',
    RemoveFromBatch: 'Remover do Lote',
    Recipe: 'Receita',
    Recipes: 'Receitas',
    RegisteredRecipes: 'Cadastro de Receita',
    RegisterRecipe: 'Cadastrar Receita',
    RecipesAndNotifications: 'Receitas e Notificações',
    Recipeconfirmed: 'Receita confirmada',
    RecipeHistory: 'Histórico de Receitas',
    RecipeRegisteredBy: 'Receita cadastrada por {user}',
    RecipeRegisteredInCustomerArea: `Receita cadastrada na Área do Cliente`,
    RecipeRegisteredInPdv: `Receita cadastrada no PDV`,
    RecipeSourcedFromTheOldSislog: 'Receita com origem no antigo Sislog.',
    RecipeUpdatedBy: 'Receita alterada por {user}',
    RecipeUpdatedInPdv: 'Receita alterada no PDV',
    RecipeUpdatedInCustomerArea: 'Receita alterada na Área do Cliente',
    Registered: 'Cadastrado',
    RegisteredOf: 'Cadastrado de',
    RegisteredUntil: 'Cadastrado até',
    ReopenIncorrectlyDeliveredOrder: 'Reabrir, pois foi entregue por engano',
    Reports: 'Relatórios',
    RequestLensesAndAssemblyAgain: 'Solicitar Lente e Montagem Novamente',
    RequestLensesAndAssembly: 'Solicitar Lente e Montagem',
    RequestLens: 'Solicitar Lentes',
    RequestInternalManufacturing: 'Solicitar Montagem Interna',
    RequestExternalManufacturing: 'Solicitar Montagem Externa',
    RequesterUser: 'Usuário Solicitante',
    Resend: 'Reenviar',
    ResendOrderForGlobalPicker: 'Reenviar Pedido para Separação Global',
    Return: 'Voltar',
    Returned: 'Devolvido',
    RevertAwaitingOrder: 'Reverter Aguardando Pedido',
    Right: 'Direito',
    RightEye: 'Olho Direito',
    RightEyeAcronym: 'OD',
    Rim: 'Aro',
    Save: 'Salvar',
    SaveLinking: 'Salvar Vinculação',
    SaveRecipe: 'Salvar Receita',
    Search: 'Pesquisar',
    SelectAtLeastOneOrder: 'Selecione pelo menos um pedido.',
    Seller: 'Vendedor',
    SeparationType: 'Tipo de Separação',
    SeparatedOrder: 'Pedido Separado',
    Series: 'Série',
    SetShippingLine: 'Definir Linha de Transporte',
    Settings: 'Configurações',
    ShippingAddress: 'Endereço de Entrega',
    ShortTitle: 'Sislog',
    Shop: 'Loja',
    Situation: 'Situação',
    Sku: 'SKU',
    Spherical: 'Esférico',
    SphericalLeft: 'Esférico Esq',
    SphericalRight: 'Esférico Dir',
    StartCheking: 'Iniciar Conferência',
    StorageSessionKey: 'session',
    State: 'Estado',
    StateDegree: 'Estado Grau',
    StateOrder: 'Estado Pedido',
    StateOfOrder: 'Estado do Pedido',
    StateOfDegree: 'Estado do Grau',
    StatusPackage: 'Situação do Pacote',
    StatusTransport: 'Situação do Transporte',
    SuccessfullyDone: 'Realizada com sucesso',
    System: 'Sistema',
    SpecialTag: 'Tag Especial',
    SpecialTags: 'Tags Especiais',
    TagForInfluencers: 'influenciadores',
    TheOrderDoesNotHaveFrameLensPairsToLink: 'O pedido não possui pares de "Armação-Lente" para realizar vinculação.',
    TheServerIsNotRespondingRefreshListAndTryAgain: 'O servidor não está respondendo. Aguarde alguns segundos, atualize a lista e tente novamente.',    
    TextAboutTheGroupedGeneralReport: 'Informa em formato CSV a evolução de um pedido, ou seja, todo o seu histórico.',
    TextAboutTheTransportOrderBaseReport: 'Informa em formato CSV o estado corrente de um pedido em transporte.',
    TransferredItemsSeparationListReport: 'Lista de Separação de Lojas Físicas',
    TextAboutTheTransferredItemsSeparationListReport: 'Informa em formato CSV a lista de separação de itens das lojas físicas que utilizaram o estoque central.',
    Transport: 'Transporte',
    TSO: 'TSO',
    Total: 'Total',
    ToAddAnOrderToTheBatchIsIsNecessaryToLogIntoTheSystem: 'Para adicionar pedido ao lote é necessário logar no sistema.',
    ToRemoveAnOrderFromTheBatchItIsBecessaryToLogInToTheSystem: 'Para remover pedido do lote é necessário logar no sistema.',
    ToGenerateBatchItIsNecessaryToLogInToTheSystem: 'Para gerar lote é necessário logar no sistema.',
    ToSaveTheRecipeItIsNecessaryToAttachTheRecipeFileOrInformTheDiagnostic: 'Para salvar a receita precisa anexar o arquivo da receita ou informar o diagnóstico.',
    TryAgainAndInformTechTeamIfProblemPersists: 'Tente novamente e informe o time Tech se o problema persistir.',
    ToFar: 'Para Longe',
    ToNear: 'Para Perto',
    Type: 'Tipo',
    UnableToGenerateBatch: 'Não foi possível gerar o lote.',
    UnidentifiedOrderToSaveTheRecipeYouNeedToIdentifyTheOrder: 'Pedido não identificado! Para salvar a receita precisa identificar o pedido.',
    UnidentifiedBatchCannotAddOrder: 'Lote não identificado. Não é possível adicionar pedido.',
    UpdatingFailedForAllOrders: 'A alteração falhou para todos os pedidos.',
    UpdatingFinishedWithSuccess: 'Alteração concluída com sucesso!',
    Update: 'Atualizar',
    UpdateList: 'Atualizar Lista',
    UseRegisteredRecipe: 'Usar Receita Cadastrada',
    User: 'Usuário',
    UseThisRecipe: 'Usar esta Receita',
    UserNotFound: 'Usuário não encontrado!',
    Vendor: 'Vendedor',
    Vertical: 'Vertical',
    VirtualCollect: 'Coleta Virtual',
    Yes: 'Sim',
    ZerezesAtHome: 'Zerezes em Casa',
    Zip: 'CEP',
    WithFailed: 'Com falha',
    WorkingDays: 'Dias Úteis'
};